import { useMemo, useState } from 'react';
export type LinkedPlantTag = {id:number;label:string;color:string};
export function useLinkedPlantTags<T extends {tags?:LinkedPlantTag[]}>(rows:T[]) {
  const [selectedTagIds,setSelectedTagIds]=useState<number[]>([]);
  const availableTags=useMemo(()=>{
    const tags=new Map<number,LinkedPlantTag>();
    rows.forEach(row=>row.tags?.forEach(tag=>tags.set(Number(tag.id),{...tag,id:Number(tag.id)})));
    return [...tags.values()].sort((a,b)=>a.label.localeCompare(b.label,'tr'));
  },[rows]);
  const tagFilteredRows=useMemo(()=>rows.filter(row=>!selectedTagIds.length || row.tags?.some(tag=>selectedTagIds.includes(Number(tag.id)))),[rows,selectedTagIds]);
  return {availableTags,selectedTagIds,setSelectedTagIds,tagFilteredRows};
}
